export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  const authObj = {
    // 报表统计
    stat: false,

    admManage: false,
    // 单位管理员
    admUser: false,
    admUserAdd: false,
    admUserEdit: false,
    admUserRemove: false,
    admUserClearFail: false,

    // 权限角色
    admRole: false,
    admRoleAdd: false,
    admRoleEdit: false,
    admRoleRemove: false,

    // 系统字典
    sysDic: false,
    sysDicAdd: false,
    sysDicEdit: false,
    sysDicRemove: false,

    // 系统日志
    admUserLog: false,
    admUserLogRemove: false,

    // 权限资源
    admRight: false,
    admRightGetTree: false,
    admRightAdd: false,
    admRightEdit: false,
    admRightRemove: false,

    // 商户管理
    shopManage: false,
    shop: false,
    shopAdd: false,
    shopEdit: false,
    shopRemove: false,
    shopOperator: false,
    shopLog: false,
    shopImport: false,

    // 用户管理
    user: false,
    userAdd: false,
    userEdit: false,
    userRemove: false,
    userRemark: false,

    // 申请管理
    workflowUser: false,
    workflowUserStreetVerify: false,
    workflowUserDistrictVerifyPre: false,
    workflowUserDistrictVerify: false,

    // 商品管理
    goodManage: false,
    good: false,
    goodExport: false,
    goodCategoryAdd: false,
    goodCategoryEdit: false,
    goodCategoryRemove: false,

    // 订单管理
    order: false,
    orderExport: false,
    orderStreetVerify: false,
    orderDistrictVerify: false,
    orderSettleBegin: false,
    orderSettleComplete: false,

    // 财务管理
    financial: false,
    userPay: false,
    userRefund: false,
    userButieLog: false,
  };

  if (currentUser !== undefined) {
    const rights = currentUser?.right_keys ?? [];
    if (rights.includes("*")) {
      Object.keys(authObj).forEach((key) => {
        // @ts-expect-error
        authObj[key] = true;
      });
    } else {
      Object.keys(authObj).forEach((key) => {
        // @ts-expect-error
        authObj[key] = rights.includes(key) || false;
      });
    }
  }

  return {
    ...authObj,
  };
}
